import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, TextField, Box, Chip } from '@mui/material';
import EditOnboardingSteps from './EditOnboardingSteps';

const EditManufacturerData = ({ 
  manufacturer, 
  editingAccount, 
  setEditingAccount, 
  getStepsForManufacturer, 
  getStatusesForManufacturer, 
  getStatusColor 
}) => (
  <Grid key={manufacturer} size={12}>
    <Typography variant="h6" color="primary" gutterBottom sx={{ mt: 2 }}>
      {manufacturer}
    </Typography>

    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 4
        }}>
        <TextField
          fullWidth
          label={
            <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              1Password User Name
              <Chip 
                label="Evoke" 
                size="small" 
                color="primary" 
                variant="outlined"
                sx={{ height: 16, fontSize: '0.65rem', fontWeight: 600 }}
              />
            </Box>
          }
          value={editingAccount.manufacturerData[manufacturer]?.credentials || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            const updatedData = {
              ...editingAccount.manufacturerData,
              [manufacturer]: {
                ...editingAccount.manufacturerData[manufacturer],
                credentials: newValue
              }
            };
            setEditingAccount(prev => ({ ...prev, manufacturerData: updatedData }));
          }}
          size="small"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>

      
      <EditOnboardingSteps 
        manufacturer={manufacturer}
        editingAccount={editingAccount}
        setEditingAccount={setEditingAccount}
        getStepsForManufacturer={getStepsForManufacturer}
        getStatusesForManufacturer={getStatusesForManufacturer}
        getStatusColor={getStatusColor}
      />
      
      <Grid size={12}>
        <TextField
          fullWidth
          label="Remarks"
          multiline
          rows={2}
          value={editingAccount.manufacturerData[manufacturer]?.remarks || ''}
          onChange={(e) => {
            const updatedData = {
              ...editingAccount.manufacturerData,
              [manufacturer]: {
                ...editingAccount.manufacturerData[manufacturer],
                remarks: e.target.value
              }
            };
            setEditingAccount(prev => ({ ...prev, manufacturerData: updatedData }));
          }}
          size="small"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
    </Grid>
  </Grid>
);

EditManufacturerData.propTypes = {
  manufacturer: PropTypes.string.isRequired,
  editingAccount: PropTypes.object.isRequired,
  setEditingAccount: PropTypes.func.isRequired,
  getStepsForManufacturer: PropTypes.func.isRequired,
  getStatusesForManufacturer: PropTypes.func.isRequired,
  getStatusColor: PropTypes.func.isRequired
};

export default EditManufacturerData;